import React, { useState } from 'react'
import { format, addDays, differenceInDays } from 'date-fns'

const BookingForm = ({ layout }) => {
  const defaultArrival = format(addDays(new Date(), 1), 'yyyy-MM-dd') // Tomorrow as default arrival
  const defaultDeparture = format(addDays(new Date(), 2), 'yyyy-MM-dd') // Day after tomorrow as default departure

  const [arrivalDate, setArrivalDate] = useState(defaultArrival)
  const [departureDate, setDepartureDate] = useState(defaultDeparture)
  // const [adults, setAdults] = useState(2)
  // const [children, setChildren] = useState(0)

  function handleArrivalChange(e) {
    const newArrival = e.target.value
    setArrivalDate(newArrival)

    if (newArrival >= departureDate) {
      setDepartureDate(format(addDays(new Date(newArrival), 1), 'yyyy-MM-dd'))
    }
  }

  function handleDepartureChange(e) {
    setDepartureDate(e.target.value)
  }

  const stayLength = differenceInDays(new Date(departureDate), new Date(arrivalDate))

  return (
    <section className='component-bookingForm bg-cyan-700 text-white p-4 w-full rounded-t-md md:rounded-md shadow-lg'>
      <form
        action='https://portal.freetobook.com/reservations'
        className={`flex w-full justify-stretch text-lg md:gap-3 flex-row flex-wrap md:flex-nowrap md:flex-row md:items-end ${layout === 'vertical' ? 'md:flex-col' : ''}`}
        method='get'>
        <input type='hidden' name='w_id' value='49092' />
        <input type='hidden' name='w_tkn' value='LWw4hOXb0QRJ1AtOoCUFMQqn77iWKi3Mzo6TcMjGImAG5D0isBZNhbjMNCK2X' />
        <input type='hidden' name='stay_length' value={stayLength.toString().padStart(2, '0')} />
        <div className='pr-2 md:pr-0 w-1/2 md:w-full mb-3 md:mb-0'>
          <label className='mb-2 block font-serif font-semibold' htmlFor='check_in_date'>
            Arrival Date
          </label>
          <input
            className='w-full appearance-none border rounded px-4 py-2 md:py-3 leading-tight text-stone-700 shadow'
            type='date'
            id='check_in_date'
            name='check_in_date'
            min={defaultArrival}
            value={arrivalDate}
            onChange={handleArrivalChange}
            onClick={(e) => e.target.showPicker && e.target.showPicker()}
          />
        </div>
        <div className='pl-2 md:pl-0 w-1/2 md:w-full mb-3 md:mb-0'>
          <label className='mb-2 block text-lg font-serif font-semibold' htmlFor='check_out_date'>
            Departure Date
          </label>
          <input
            className='w-full appearance-none border rounded px-4 py-2 md:py-3 leading-tight text-stone-700 shadow'
            type='date'
            id='check_out_date'
            name='check_out_date'
            min={format(addDays(new Date(arrivalDate), 1), 'yyyy-MM-dd')}
            value={departureDate}
            onChange={handleDepartureChange}
            onClick={(e) => e.target.showPicker && e.target.showPicker()}
          />
        </div>

        <div className='w-full'>
          <button type='submit' className='button button-bold w-full'>
            Check Availability
          </button>
        </div>
      </form>
    </section>
  )
}

export default BookingForm
